export const getNonce = () => {
  const nonce = document.querySelector('meta[property="csp-nonce"]')?.getAttribute('nonce') || ''

  /* NOTE: Temporarely fix for nonce provlem with REact-Query Developer tool.
  * Ref.: https://github.com/TanStack/query/pull/10736
  */
  if (process.env.NODE_ENV === 'development' && nonce) {
    // @ts-expect-error - This is a custom property we are adding to the window object to store the nonce value for development purposes.
    window.__nonce__ = nonce
  }

  return nonce
}
